/**
 * 批次明细交易信息查询
 */
<template>
  <div class="data-center-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>批次明细交易信息查询</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="订单ID :">
            <el-input
              size="small"
              v-model="formInline.detailId"
              placeholder="请输入订单ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="订单状态 :">
            <el-select
              size="small"
              v-model="formInline.status"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in status_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="服务费:">
            <el-input
              size="small"
              v-model="formInline.minServiceFee"
              placeholder="请输入"
              style="width: 47%"
            ></el-input>
            ~
            <el-input
              size="small"
              v-model="formInline.maxServiceFee"
              placeholder="请输入"
              style="width: 47%"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="证件号 :">
            <el-input
              size="small"
              v-model="formInline.idNumber"
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="创建时间 : ">
            <el-date-picker
              size="small"
              v-model="formInline.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="table-toolbar">
      <el-button size="small" type="primary" @click="exportData"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      empty-text="暂无数据"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <!-- <el-table-column prop="merchantName" label="商户名称" width="200">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="detailId"
        label="订单ID"
        min-width="160"
      >
        <template slot-scope="scope">
          <span
            class="id-text"
            :title="scope.row.detailId || '-'"
            @dblclick="copyToClipboard(scope.row.detailId)"
            >{{ scope.row.detailId || "-" }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="收款信息" min-width="200">
        <template slot-scope="scope">
          <span v-cloak>{{ scope.row.paymentChannelStr }}</span
          ><br />
          <span v-cloak>{{ scope.row.payeeAccount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="证件信息" min-width="200">
        <template slot-scope="scope">
          <span>
            {{ scope.row.identityDocumentTypeStr }}<br />
            {{ scope.row.identityDocumentNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="statusStr" label="订单状态" min-width="110">
        <template slot-scope="scope">
          <span :style="{ color: getStatusColor(scope.row.status, scope.row.statusStr) }">
            {{ scope.row.statusStr || "-" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceFee" label="服务费（元）" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.serviceFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amountReceived"
        label="到账金额（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFee"
        label="管理费（元）"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.managementFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxMode"
        label="个税承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.individualIncomeTaxMode === 1">企业承担</span>
          <span v-else-if="scope.row.individualIncomeTaxMode === 2"
            >个人承担</span
          >

          <span v-else-if="scope.row.individualIncomeTaxMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxRate"
        label="个税税率"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="individualIncomeTax"
        label="个税（元）"
        min-width="110"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.individualIncomeTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="valueAddedTax"
        label="增值税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.valueAddedTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
        <el-table-column
        prop="additionalTax"
        label="附加税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.additionalTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="paymentRemark" label="收款备注" min-width="100">
      </el-table-column>
      <!-- <el-table-column prop="actionId" label="操作账号" width="200">
      </el-table-column> -->
      <el-table-column prop="createdAt" label="创建时间" min-width="150">
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" min-width="150">
      </el-table-column>
      <el-table-column prop="batchName" label="批次名称" min-width="140">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="部门名称" prop="deptName">
          <el-input
            size="small"
            v-model="editForm.deptName"
            auto-complete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input
            size="small"
            v-model="editForm.deptNo"
            auto-complete="off"
            placeholder="请输入部门代码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { settlementsListdetails, exportsettlements } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      status_list: [
        {
          label: "校验中",
          value: 1,
        },
        {
          label: "初验成功",
          value: 2,
        },
        {
          label: "验证失败",
          value: 3,
        },
        {
          label: "已取消",
          value: 4,
        },
        {
          label: "待结算",
          value: 5,
        },
        {
          label: "结算中",
          value: 6,
        },
        {
          label: "结算成功",
          value: 7,
        },
        {
          label: "结算失败",
          value: 8,
        },
        {
          label: "已退款",
          value: 9,
        },
        {
          label: "已退票",
          value: 10,
        },
        {
          label: "银行挂账",
          value: 11,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        date: [],
        positionId: "",
        positionName: "",
        positionState: "",
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        merchantName: "",
        date: [],
        name: "",
        detailId: "",
        batchNumber: "",
        status: "",
        minServiceFee: "",
        maxServiceFee: "",
        idNumber: "",
        taskName: "",
        transactionStartDate: "",
        transactionEndDate: "",
        settlementInfo: "",
        mobile: "",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    copyToClipboard(text) {
      const value = (text || "").toString().trim();
      if (!value) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(value).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        const input = document.createElement("textarea");
        input.value = value;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
    getStatusColor(status, statusStr) {
      const map = {
        1: "#409EFF",
        2: "#67C23A",
        3: "#F56C6C",
        4: "#909399",
        5: "#E6A23C",
        6: "#409EFF",
        7: "#67C23A",
        8: "#F56C6C",
        9: "#909399",
        10: "#909399",
        11: "#E6A23C",
      };
      if (map[status]) return map[status];
      const text = statusStr || "";
      if (text.indexOf("成功") !== -1 || text.indexOf("初验") !== -1) {
        return "#67C23A";
      }
      if (text.indexOf("失败") !== -1) return "#F56C6C";
      if (text.indexOf("中") !== -1) return "#409EFF";
      if (
        text.indexOf("待") !== -1 ||
        text.indexOf("挂账") !== -1
      ) {
        return "#E6A23C";
      }
      if (
        text.indexOf("取消") !== -1 ||
        text.indexOf("退款") !== -1 ||
        text.indexOf("退票") !== -1
      ) {
        return "#909399";
      }
      return "#303133";
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        merchantName: "",
        date: [],
        name: "",
        detailId: "",
        batchNumber: "",
        status: "",
        minServiceFee: "",
        maxServiceFee: "",
        idNumber: "",
        taskName: "",
        transactionStartDate: "",
        transactionEndDate: "",
        settlementInfo: "",
        mobile: "",
      };
      this.getdata(this.formInline);
    },
    detail_list() {},
    //导出数据
    exportData() {
      let params = {
        page: 1,
        pageSize: 999999999,
        merchantName: this.formInline.merchantName,
        name: this.formInline.name,
        detailId: this.formInline.detailId,
        batchNumber: this.formInline.batchNumber,
        status: this.formInline.status,
        minServiceFee: this.formInline.minServiceFee,
        maxServiceFee: this.formInline.maxServiceFee,
        idNumber: this.formInline.idNumber,
        taskName: this.formInline.taskName,
        transactionStartDate: this.formInline.date[0] || "",
        transactionEndDate: this.formInline.date[1] || "",
        settlementInfo: this.formInline.settlementInfo,
        mobile: this.formInline.mobile,
      };
      exportsettlements(params).then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 获取公司列表
    getdata(parameter) {
      parameter.createdStartDate = parameter.date[0] || "";
      parameter.createdEndDate = parameter.date[1] || "";
      settlementsListdetails(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // this.listData.map(item => {
            //   if(item.recruitmentStateDesc == '上线'){
            //     item.status = true
            //   }else{
            //     item.status = false
            //   }
            // })
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          // this.$message.error('菜单加载失败，请稍后再试！')
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false;
        }
      });
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.data-center-page {
  padding-bottom: 8px;
}
.user-search {
  margin-top: 16px;
  margin-bottom: 12px;
  padding: 16px 16px 6px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.table-toolbar {
  margin-bottom: 12px;
}
.id-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: bottom;
  cursor: pointer;
}
</style>

 


// WEBPACK FOOTER //
// src/views/dataCenter/batchmation.vue